import {
    Button,
    Paper,
    ToggleButtonGroup,
    Tooltip,
    IconButton,
    Typography,
    ToggleButton,
} from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridWeek from "@fullcalendar/timegrid"
import listPlugin from '@fullcalendar/list';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import interactionPlugin from "@fullcalendar/interaction";
import { createRef } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

const HolidayCalender = ({ holidayData, selectedYear, selectyear,onCalendarYearChange, disableViewType }) => {
    const calendarRef = createRef();
    const [title, setTitle] = useState();
    const [viewType, setViewType] = useState("dayGridMonth");
    useEffect(() => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            if (selectyear) {
                calendarApi.gotoDate(`${selectedYear}-01-01`);
            }
            setTitle(calendarApi?.currentDataManager?.data?.viewTitle);
        }
    }, [selectedYear]);
    const handleChange = (type) => {
        let calendarApi = calendarRef.current.getApi();
        const oldYear = new Date(calendarApi.getDate()).getFullYear();
    
        if (type === "today") calendarApi.today();
        else if (type === "next") calendarApi.next();
        else if (type === "prev") calendarApi.prev();
    
        const newDate = calendarApi.getDate();
        const newYear = new Date(newDate).getFullYear();
    
        setTitle(calendarApi?.currentDataManager?.data?.viewTitle);
    
        // If year has changed, update parent and refetch holidays
        if (newYear !== oldYear) {
            // Update dropdown in parent (trigger useEffect)
            onCalendarYearChange && onCalendarYearChange(newYear);
        }
    };

    const handleAlignment = (event, newAlignment) => {
        setViewType(newAlignment);
    };
    const handleViewTypeChange = (viewType) => {
        let calendarApi = calendarRef.current.getApi();
        calendarApi.changeView(viewType);
        calendarApi = calendarRef.current.getApi();
        setTitle(calendarApi?.currentDataManager?.data?.viewTitle);
    };
    const eventContent = ({ event }) => {
        const { extendedProps } = event;
        const { name, description } = extendedProps;

        return (
            <div
                style={{
                    backgroundColor: "#fdf3c4", // Light pastel background
                    color: "#4a2f00", // Dark text for contrast
                    borderRadius: "10px",
                    fontFamily: "Nunito Sans",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                    transition: "transform 0.2s",
                    cursor: "pointer",
                    maxWidth: "100%", // Prevents content from overflowing
                    overflow: "hidden",
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            >
                <div style={{ flexGrow: 1, overflow: "hidden" }}>
                    <div
                        style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%"
                        }}
                        title={name}
                    >
                        {name}
                    </div>
                    {description && (
                        <div
                            style={{
                                fontSize: "12px",
                                color: "#6b4e00",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%"
                            }}
                            title={description}
                        >
                            {description}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <Paper
                sx={{ borderRadius: "16px", mt:"-7px",backgroundColor: "#f3edfd" }}
                elevation={2}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "20px",
                    }}
                >
                    { !disableViewType && (<div style={{ display: "flex", flexDirection: "row" }}>
                        <ToggleButtonGroup
                            exclusive
                            value={viewType}
                            onChange={handleAlignment}
                            aria-label="view type"
                        >
                            <ToggleButton
                                onClick={() => handleViewTypeChange("dayGridMonth")}
                                value="dayGridMonth"
                                aria-label="Month"
                            >
                                <Tooltip title="Month">
                                    <ViewModuleIcon fontSize="small" />
                                </Tooltip>
                            </ToggleButton>
                            <ToggleButton onClick={() => handleViewTypeChange('timeGridWeek')} value='timeGridWeek' aria-label='Week'>
                                <Tooltip title="Week">
                                    <ViewWeekIcon fontSize="small" />
                                </Tooltip>
                            </ToggleButton>
                            <ToggleButton onClick={() => handleViewTypeChange('listWeek')} value='listWeek' aria-label='List Week'>
                                <Tooltip title="Agenda">
                                    <ViewStreamIcon fontSize="small" />
                                </Tooltip>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>)}

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <IconButton onClick={() => handleChange("prev")}>
                            <ArrowBackIosNewIcon sx={{ width: "0.7em", height: "0.75em" }} />
                        </IconButton>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 700,
                                fontSize: "1.2rem",
                                margin: "0px 16px 0px 16px",
                            }}
                        >
                            {title}
                        </Typography>
                        <IconButton onClick={() => handleChange("next")}>
                            <ArrowForwardIosIcon sx={{ width: "0.7em", height: "0.75em" }} />
                        </IconButton>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            onClick={() => handleChange("today")}
                            sx={{
                                fontWeight: 700,
                                borderRadius: "8px",
                                fontSize: "13px",
                                height: "30px",
                                padding: "4px 10px",
                                boxShadow: "none",
                                lineHeight: 1.71429,
                            }}
                            size="small"
                            variant="contained"
                            className="mpl-primary-btn"
                        >
                            Today
                        </Button>
                    </div>
                </div>
                <FullCalendar
                    headerToolbar={false}
                    plugins={[dayGridPlugin, interactionPlugin, timeGridWeek, listPlugin]}
                    initialView="dayGridMonth"
                    contentHeight={500}
                    events={holidayData || []}
                    eventContent={eventContent}
                    ref={calendarRef}
                />

            </Paper>
        </>
    );
};

export default HolidayCalender;
